module.exports = __webpack_public_path__ + "img/scarlets.95a8c78e.jpeg";